document.querySelectorAll('[name="options[COLOUR]"]').forEach(function(option){
    var selected_value = option.value;
    option.addEventListener("change", function(){
        var selected = this.value;
        document.querySelectorAll('[name="options[COLOUR]"] option').forEach(function(o){
          if(o.getAttribute("value") == selected){
            document.querySelectorAll('[name="properties[Custom Color]"]').forEach(function(name){
              name.value = o.textContent.trim()
            })
          }
        })
    })

  document.querySelectorAll('[name="options[COLOUR]"] option').forEach(function(o){
    if(o.getAttribute("value") == selected_value){
      document.querySelectorAll('[name="properties[Custom Color]"]').forEach(function(name){
        name.value = o.textContent.trim()
      })
    }
  })
});

